export default {
    name: 'units',
    component: () => import(/* webpackChunkName: "units-Layout" */ '@/modules/units/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.units.index',
            component: () => import(/* webpackChunkName: "units-index" */ '@/modules/units/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.units.create',
            component: () => import(/* webpackChunkName: "units-create" */ '@/modules/units/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.units.edit',
            component: () => import(/* webpackChunkName: "units-edit" */ '@/modules/units/views/Edit'),
        },
    ]
}